import { Navigate, RouteObject } from 'react-router-dom';

import { PUBLIC_PAGE_ROUTES } from '@/enums';
import { isSelfSignUpEnabled } from '@/helpers';
import {
  CheckEmailPage,
  ConfirmEmailChange,
  Login,
  MfaVerify,
  Register,
  SendEmail,
  SetPassword,
  WatchStream
} from '@/pages';

import { PublicOnlyRoute } from '../PublicOnlyRoute';

export const publicRoutes: RouteObject[] = [
  {
    path: PUBLIC_PAGE_ROUTES.STREAM,
    element: <WatchStream />
  },
  {
    path: PUBLIC_PAGE_ROUTES.LOGIN,
    element: (
      <PublicOnlyRoute>
        <Login />
      </PublicOnlyRoute>
    )
  },
  {
    path: PUBLIC_PAGE_ROUTES.SET_PASSWORD,
    element: (
      <PublicOnlyRoute>
        <SetPassword />
      </PublicOnlyRoute>
    )
  },
  {
    path: PUBLIC_PAGE_ROUTES.CHECK_EMAIL,
    element: (
      <PublicOnlyRoute>
        <CheckEmailPage />
      </PublicOnlyRoute>
    )
  },
  {
    path: PUBLIC_PAGE_ROUTES.SEND_EMAIL,
    element: (
      <PublicOnlyRoute>
        <SendEmail />
      </PublicOnlyRoute>
    )
  },
  {
    path: PUBLIC_PAGE_ROUTES.MFA_VERIFY,
    element: (
      <PublicOnlyRoute>
        <MfaVerify />
      </PublicOnlyRoute>
    )
  },
  {
    path: PUBLIC_PAGE_ROUTES.REGISTER,
    element: isSelfSignUpEnabled() ? (
      <PublicOnlyRoute>
        <Register />
      </PublicOnlyRoute>
    ) : (
      <Navigate to={PUBLIC_PAGE_ROUTES.LOGIN} replace />
    )
  },
  {
    path: PUBLIC_PAGE_ROUTES.CONFIRM_EMAIL_CHANGE,
    element: <ConfirmEmailChange />
  }
];
